(function() {
  'use strict';
  
  // Function to toggle review sections based on review count
  function toggleReviewSections() {
    const reviewContainer = document.querySelector('.jdgm-rev-widg__reviews');
    const reviewCount = reviewContainer ? reviewContainer.querySelectorAll('div').length : 0;
    
    // Use attribute selectors to find review blocks dynamically
    const reviewWidget = document.querySelector('[id*="judge_me_reviews_review_widget"]');
    const allReviewsPage = document.querySelector('[id*="judge_me_reviews_all_reviews"]');
    
    if (reviewCount === 0) {
      if (reviewWidget) {
        reviewWidget.classList.add('review_section_hide');
      }
    } else {
      if (allReviewsPage) {
        allReviewsPage.classList.add('review_section_hide');
      }
    }
  }
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewToggle);
  } else {
    initReviewToggle();
  }
  
  function initReviewToggle() {
    // Try to find reviews immediately
    const reviewContainer = document.querySelector('.jdgm-rev-widg__reviews');
    
    if (reviewContainer) {
      // Reviews container exists, check immediately
      toggleReviewSections();
    } else {
      // Use MutationObserver to watch for review content loading
      let hasToggled = false;
      const observer = new MutationObserver(function() {
        const reviewContainer = document.querySelector('.jdgm-rev-widg__reviews');
        if (reviewContainer && !hasToggled) {
          toggleReviewSections();
          hasToggled = true;
          observer.disconnect(); // Stop observing once we've found the reviews
        }
      });
      
      // Start observing the document body for changes
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // Fallback: try after a delay (in case MutationObserver doesn't catch it)
      setTimeout(function() {
        if (!hasToggled) {
          toggleReviewSections();
          observer.disconnect();
        }
      }, 3000);
    }
  }
})();

